/**
 * Created by TzuHsing on 2020-10-14
 */
import React, { Component } from 'react'
import { Button, Input, Switch, Checkbox, TimePicker } from "antd"
import moment from 'moment'
const CheckboxGroup = Checkbox.Group

class AddPackage extends Component {
  state = {
    plainOptions: [
      { label: '周一', value: 1, disabled: false, postData: '1' },
      { label: '周二', value: 2, disabled: false, postData: '1' },
      { label: '周三', value: 3, disabled: false, postData: '1' },
      { label: '周四', value: 4, disabled: false, postData: '1' },
      { label: '周五', value: 5, disabled: false, postData: '1' },
      { label: '周六', value: 6, disabled: false, postData: '1' },
      { label: '周日', value: 7, disabled: false, postData: '1' },
    ],
    checkedList: [1, 2, 3, 4, 5, 6, 7],
    startTime: new Date(),
    endTiem: new Date()
  }

  componentDidMount() {
    const sd = new Date()
    sd.setHours(0, 0)
    this.setState({
      startTime: sd,
      endTiem: sd,
    })
  }

  onChange = (list) => {
    const newOptions = this.state.plainOptions.map((item) => {
      if (list.includes(item.value)) {
        item.postData = '1'
        if (list.length == 1) {
          item.disabled = true
        } else {
          item.disabled = false
        }
      } else {
        item.postData = '0'
      }
      return item
    })
    this.setState((preState) => ({
      checkedList: list.length > 0 ? list : preState.checkedList,
      plainOptions: newOptions
    }), () => {
      const weeks = []
      this.state.plainOptions.forEach(element => {
        weeks.push(element.postData)
      })
      this.props.setTypingInfo('purchaseWeekday', weeks)
    })
  }

  timeSOnChange = (value, dateString) => {
    if (value) {
      this.props.setTypingInfo('purchaseStartTime', dateString)
      this.setState({
        startTime: value
      })
    }
  };

  timeEOnChange = (value, dateString) => {
    if (value) {
      this.props.setTypingInfo('purchaseEndTime', dateString)
      this.setState({
        endTiem: value
      })
    }
  };

  createPackage = () => {
    this.props.handleCreatePackage()
    const sd = new Date()
    sd.setHours(0, 0)
    this.setState({
      plainOptions: [
        { label: '周一', value: 1, disabled: false, postData: '1' },
        { label: '周二', value: 2, disabled: false, postData: '1' },
        { label: '周三', value: 3, disabled: false, postData: '1' },
        { label: '周四', value: 4, disabled: false, postData: '1' },
        { label: '周五', value: 5, disabled: false, postData: '1' },
        { label: '周六', value: 6, disabled: false, postData: '1' },
        { label: '周日', value: 7, disabled: false, postData: '1' },
      ],
      checkedList: [1, 2, 3, 4, 5, 6, 7],
      startTime: sd,
      endTiem: sd,
    })
  }

  render() {
    const { plainOptions, checkedList, startTime, endTiem } = this.state
    const { typingPackageName, typingPackagePrice, typingPackageTime, isBindAfterAdd, isPurchaseLimitEnabled, setTypingInfo, setTypingSwitch, hideSwitch } = this.props
    return (
      <div className='add-package-box'>
        <div className="addPackage-Box displayFlexRow">
          <div className='displayFlexRow' style={{ width: '47%' }}>
            <div className='displayFlexColumn'>套餐名</div>
            <div className='displayFlexColumn' style={{ width: '70%' }}>
              <Input onChange={(e) => {
                setTypingInfo('typingPackageName', e.target.value)
              }} value={typingPackageName} />
            </div>
          </div>
          <div className='displayFlexRow' style={{ width: '42%' }}>
            <div className='displayFlexColumn'>价格（元）</div>
            <div className='displayFlexColumn' style={{ width: '50%' }} >
              <Input onChange={(e) => {
                const newText = e.target.value
                const isAllowText = /^\d+(\.\d{0,2})?$/.test(newText);
                (isAllowText || newText === '') && setTypingInfo('typingPackagePrice', e.target.value)
              }} value={typingPackagePrice} />
            </div>
          </div>
          <div className='displayFlexRow' style={{ width: '39%' }}>
            <div className='displayFlexColumn'>时长（分钟）</div>
            <div className='displayFlexColumn' style={{ width: '43%' }}>
              <Input onChange={(e) => {
                const newText = e.target.value
                const isAllowText = /^\d+(\.\d{0,2})?$/.test(newText);
                (isAllowText || newText === '') && setTypingInfo('typingPackageTime', e.target.value)
              }} value={typingPackageTime} />
            </div>
          </div>
          {
            !hideSwitch && <div className='displayFlexRow' style={{ width: '30%' }}>
              <div className='displayFlexColumn'>立即启用</div>
              <div className='displayFlexColumn' style={{ height: '100%' }}>
                <Switch style={{}} onChange={() => {
                  setTypingSwitch('isBindAfterAdd')
                }} checked={isBindAfterAdd} /></div>
            </div>
          }
          {
            <div className='displayFlexRow' style={{ width: '30%' }}>
              <div className='displayFlexColumn'>限时购买</div>
              <div className='displayFlexColumn' style={{ height: '100%' }}>
                <Switch style={{}} onChange={() => {
                  setTypingSwitch('isPurchaseLimitEnabled')
                }} checked={isPurchaseLimitEnabled} /></div>
            </div>
          }
          <div className='displayFlexRow' style={{ width: '30%' }}>
            <Button className='ant-btn-primary' onClick={this.createPackage}>新建套餐</Button>
          </div>
        </div>
        {isPurchaseLimitEnabled && (
          <div className='add-package-box-date-view'>
            <span className='date-tip-text'>限时购买使用</span>
            <TimePicker
              id="stime"
              format="HH:mm"
              placeholder='开始时间'
              value={moment(startTime)}
              onChange={this.timeSOnChange}
            />
            <TimePicker
              id="etime"
              format="HH:mm"
              placeholder='结束时间'
              value={moment(endTiem)}
              onChange={this.timeEOnChange}
            />
            <div className='add-package-box-check-box'>
              <CheckboxGroup options={plainOptions} value={checkedList} onChange={this.onChange} />
            </div>
          </div>
        )}
      </div>
    )
  }
}


export default AddPackage


// WEBPACK FOOTER //
// ./src/containers/ClubTable/component/AddPackage.js